import { useAccount, useReadContract } from 'wagmi';
import { formatEther } from 'viem';

import {
  SANKO_WAGER_ADDR,
  dmtContract,
  RPC_POLLING_INTERVAL,
} from '@src/lib/consts';

export default function useWagerAllowance() {
  const { address } = useAccount();
  return useReadContract({
    ...dmtContract,
    functionName: 'allowance',
    args: [address!, SANKO_WAGER_ADDR],
    query: {
      enabled: !!address,
      select: (allowanceData) => formatEther(allowanceData),
      refetchInterval: RPC_POLLING_INTERVAL,
    },
  });
}
